<script setup lang="ts">
import { computed, ref, type PropType, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import type { CommentThanksDTO } from '@/composables/memorize/memorize'
const { t } = useI18n()
import { formatFriendlyTime } from '@/utils/time'
import { currentLang } from '@/composables/settings/storage'
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  thank: {
    type: Object as PropType<CommentThanksDTO | null>,
    default: null
  }
})

const showThankDialog = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit('update:modelValue', value)
  }
})
const thankName = computed(() => {
  return props.thank?.thankName || ''
})
const thankTime = computed(() => {
  return props.thank?.createdAt || ''
})
const thankContent = computed(() => {
  return props.thank?.contentText || ''
})

const time = computed(() => {
  if (!thankTime.value) return ''
  const getTime = formatFriendlyTime(thankTime.value as number, currentLang.value)
  return getTime
})

const emit = defineEmits(['update:modelValue'])
</script>
<template>
  <!--  查看答谢词弹窗 -->
  <el-dialog v-model="showThankDialog" w-100 rounded-2 :lock-scroll="false" p-4 :show-close="false">
    <div text-center text-xl font-bold mt--2 mx-auto>{{ t('m.thank_content') }}</div>
    <div w-full p-2 mt-5 pb-1>
      <div text-lg w-full min-h-40 input-base p-4>
        {{ thankContent }}
      </div>

      <div flex flex-col justify-center items-end mt-8 w-full>
        <div text-main text-lg>{{ thankName }}</div>
        <div text-third text-sm>{{ time }}</div>
      </div>
    </div>
  </el-dialog>
</template>
<style scoped>
:deep(.el-icon) {
  height: 4em !important;
}
</style>
